import store from '@/store'; // Importiere den Vuex-Store

export function getXmlValueFE(xpath, index) {
    if (!index) index = 0
    const placeholder = store.state.xPathPlaceholders.find(mapping => mapping.xpath == xpath);
    return placeholder && placeholder.value ? placeholder.value[index] : null;
  }